"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateMixedVoiceoverResponseToJSON = exports.GenerateMixedVoiceoverResponseFromJSONTyped = exports.GenerateMixedVoiceoverResponseFromJSON = exports.instanceOfGenerateMixedVoiceoverResponse = void 0;
var runtime_1 = require("../runtime");
var GenerateAdError_1 = require("./GenerateAdError");
var TextWithTimestamp_1 = require("./TextWithTimestamp");
/**
 * Check if a given object implements the GenerateMixedVoiceoverResponse interface.
 */
function instanceOfGenerateMixedVoiceoverResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGenerateMixedVoiceoverResponse = instanceOfGenerateMixedVoiceoverResponse;
function GenerateMixedVoiceoverResponseFromJSON(json) {
    return GenerateMixedVoiceoverResponseFromJSONTyped(json, false);
}
exports.GenerateMixedVoiceoverResponseFromJSON = GenerateMixedVoiceoverResponseFromJSON;
function GenerateMixedVoiceoverResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transcript': !(0, runtime_1.exists)(json, 'transcript') ? undefined : (json['transcript'].map(TextWithTimestamp_1.TextWithTimestampFromJSON)),
        'mixUrl': !(0, runtime_1.exists)(json, 'mix_url') ? undefined : json['mix_url'],
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (json['errors'].map(GenerateAdError_1.GenerateAdErrorFromJSON)),
    };
}
exports.GenerateMixedVoiceoverResponseFromJSONTyped = GenerateMixedVoiceoverResponseFromJSONTyped;
function GenerateMixedVoiceoverResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transcript': value.transcript === undefined ? undefined : (value.transcript.map(TextWithTimestamp_1.TextWithTimestampToJSON)),
        'mix_url': value.mixUrl,
        'errors': value.errors === undefined ? undefined : (value.errors.map(GenerateAdError_1.GenerateAdErrorToJSON)),
    };
}
exports.GenerateMixedVoiceoverResponseToJSON = GenerateMixedVoiceoverResponseToJSON;
